import { IcArrowback } from '@yanolja-org/nol-icons';

import { LogoOrAction } from './LogoOrAction';

import type { HeaderLogoProps } from '@yanolja-org/core-ui';

export interface LogoOrBackProps {
  /** Logo 케이스 — Header.Logo 의 logo prop pass-through. 미명시 시 bi widget 자동 fetch */
  logo?: HeaderLogoProps['logo'];
  /** Logo 케이스 — Header.Logo 의 href. SEO crawler 의 link graph 용도. 사용자 클릭은 onAction 이 가로챔. @default '/' */
  logoHref?: string;
  /** Back 케이스 — Header.Action 의 action 식별자. @default 'back' */
  backAction?: string;
  /** 공통 — className */
  className?: string;
}

export function LogoOrBack({ logo, logoHref = '/', backAction = 'back', className }: LogoOrBackProps) {
  return (
    <LogoOrAction action={backAction} className={className} icon={<IcArrowback />} logo={logo} logoHref={logoHref} />
  );
}
